export enum ButtonType
{
    default = "",
    primary = "btn--primary",
    danger = "btn--danger",
    transparent = "btn--transparent"
}